import { CloudUpload } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

// Componente DropZone
const DropZone = ({
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handleFileInput,
  theme,
  styles,
  sizeFull,
  MAX_SIZE_MB_DEFAULT,
}) => (
  <Box
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
    sx={{
      ...styles.dropZone,
      ...(sizeFull >= MAX_SIZE_MB_DEFAULT && {
        opacity: 0.5,
        cursor: "not-allowed",
      }),
    }}
    onClick={() => document.getElementById("file-input")?.click()}
  >
    <CloudUpload
      sx={{
        fontSize: 64,
        color: theme.palette.primary.main,
      }}
    />
    <Typography sx={styles.TitleDrop}>
      Arraste e solte suas imagens aqui
    </Typography>
    <Typography variant="body2" color="text.secondary">
      ou clique para selecionar arquivos
    </Typography>
    <Typography variant="caption" color="text.secondary">
      Máx: {MAX_SIZE_MB_DEFAULT} MB por upload
    </Typography>
    <input
      id="file-input"
      type="file"
      multiple
      accept=".png, .jpg, .jpeg, .svg"
      onChange={handleFileInput}
      style={{ display: "none" }}
    />
  </Box>
);

export { DropZone };
